<script>
	import HubspotForm from './HubspotForm.svelte';
</script>

<div class="mt-8 xl:mt-0">
	<div class="mb-3">
		<h3 class="text-lg font-bold uppercase leading-9 tracking-wider text-thatBlue-700">
			Build Your Network
		</h3>
		<p class="max-w-lg text-base text-gray-500">
			Get the <span class="font-bold">5-minute newsletter</span> teaching tens of thousands how to grow
			their network and create the career they love in tech.
		</p>
	</div>

	<HubspotForm formId={'newsletter-footer'} />
</div>
